import { AutoMap } from '@automapper/classes';

export class CassetteEntity {
    @AutoMap()
    Id?: number;
    @AutoMap()
    Reference!: string;
    @AutoMap()
    TypeTetePrelevement!: number;
    @AutoMap()
    RefTetePrelevement!: string;
    @AutoMap()
    Integrite!: number;
    @AutoMap()
    DureePrelevement!: string;
    PlageHoraireIds?: number[];
    PompeId?: number;
}
